import { Link } from "react-router";
import logoE50 from "@assets/events-awards/logo-e50.png";
import { E50_FOOTER_MENU } from "@e50/components/E50Constants";
import FooterMenuLinks from "@events-awards/components/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_E50_PATH } from "@events-awards/utils/constants";

/**
 * Component to display footer for mobile view in E50 pages
 */
const E50FooterMobile = (): React.ReactElement => {
  return (
    <div
      className="w-full pb-2 text-center"
      data-testid="e50-footer-mobile-component"
    >
      <div className="mb-12 flex w-full flex-col items-center justify-center">
        <Link to={EVENTS_AWARDS_E50_PATH} reloadDocument>
          <img
            src={logoE50}
            alt="Singapore Corporate Awards logo"
            width={124}
            height={166}
          />
        </Link>
      </div>

      <div>
        <h3 className="mb-2 text-left font-poppins text-base font-medium">
          About Us
        </h3>

        <p className="text-left text-base leading-[1.4] text-white">
          The E50 Awards seek to recognise the 50 most enterprising local,
          privately-held companies who have contributed to the economic
          development of Singapore, both locally and abroad.
        </p>
      </div>

      <div className="-mx-0 mt-12 flex w-full flex-row">
        <div className="w-1/2">
          <h3 className="mb-4 text-left font-public-sans text-base font-semibold">
            Sections
          </h3>

          <FooterMenuLinks
            items={E50_FOOTER_MENU.slice(0, 6)}
            className="space-y-4"
          />
        </div>

        <div className="w-1/2 pl-3">
          <h3 className="mb-4 text-left font-public-sans text-base font-semibold">
            Quick Links
          </h3>

          <FooterMenuLinks
            items={E50_FOOTER_MENU.slice(6, 9)}
            className="space-y-4"
          />
        </div>
      </div>
    </div>
  );
};

export default E50FooterMobile;
